import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { BiCheck, BiChevronLeft } from "react-icons/bi";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "./validation";

const Create = ({ onSubmit, id, cancel }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.STORE);
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });
  return (
    <Formik
      initialValues={{ name: null, phone: null, email: null }}
      onSubmit={onSubmit}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
      )}
    >
      {({ isValid, handleSubmit, ...formProps }) => [
        <Header
          key={"header"}
          title={CREATE.HEADER.TITLE}
          subtitle={CREATE.HEADER.ACTION}
          actions={[
            {
              text: CREATE.HEADER.DISCARD,
              onClick: cancel,
              type: "primary--outlined",
              icon: <BiChevronLeft size={20} />,
            },
            {
              text: CREATE.HEADER.SAVE,
              onClick: handleSubmit,
              type: "primary",
              icon: <BiCheck size={20} />,
            },
          ]}
        />,
        <Card key="card" type={"simple"}>
          <div className="grid--3">
            <Input
              label={FORM.NAME}
              placeholder={FORM.NAME}
              {...bindInputProps({ name: "name", ...formProps })}
            />
            <Input
              label={FORM.PHONE}
              placeholder={FORM.PHONE}
              {...bindInputProps({ name: "phone", ...formProps })}
            />
            <Input
              label={FORM.EMAIL}
              placeholder={FORM.EMAIL}
              {...bindInputProps({ name: "email", ...formProps })}
            />
          </div>
          <div className="grid--3">
            <Input
              label={FORM.ADDRESS}
              placeholder={FORM.ADDRESS}
              {...bindInputProps({ name: "address", ...formProps })}
            />
            <Input
              label={FORM.ZIP_CODE}
              placeholder={FORM.ZIP_CODE}
              {...bindInputProps({ name: "zipCode", ...formProps })}
            />
            <Input
              label={FORM.CITY}
              placeholder={FORM.CITY}
              {...bindInputProps({ name: "city", ...formProps })}
            />
          </div>
        </Card>,
      ]}
    </Formik>
  );
};

export default Create;
